export enum PRODUCT_PRICE_ITEM_TYPE {
    product = 'Product',
    fee = 'Fee',
    volumeDiscount = 'VolumeDiscount',
    amountOffAutoDiscount = 'AmountOffAutoDiscount',
}
